import React from "react";
import moment from "moment";
import Chart from "react-apexcharts";
import { useSelector } from "react-redux";
import { groupDataByWeek } from "../../utils/datetime";
import { useTranslation } from "react-i18next";

const PlanLineChart = ({ assigmentsData = [] }) => {
	const { t } = useTranslation();
	// Procesar datos para el gráfico
	const { series, labels } = groupDataByWeek(assigmentsData);

	// Opciones del gráfico
	const options = {
		chart: {
			height: 350,
			type: "line",
			toolbar: {
				show: false,
			},
			zoom: {
				enabled: false,
			},
		},
		colors: series.map((s) => s.color),
		dataLabels: {
			enabled: false,
		},
		stroke: {
			curve: "smooth",
			width: 3,
		},
		title: {
			text: t('plan.charts.hoursDistributionByWeek'),
			align: "left",
		},
		grid: {
			borderColor: "#e0e0e0",
			row: {
				colors: ["#f3f3f3", "transparent"],
				opacity: 0.5,
			},
		},
		markers: {
			size: 5,
		},
		xaxis: {
			categories: labels,
			title: {
				text: t('plan.charts.weeks'),
			},
		},
		yaxis: {
			title: {
				text: t('plan.charts.hours'),
			},
		},
		legend: {
			position: "top",
			horizontalAlign: "right",
		},
		tooltip: {
			y: {
				formatter: function (val) {
					return val + " " + t('plan.charts.hoursUnit');
				},
			},
		},
	};

	return (
		<div className="chart-container">
			<Chart options={options} series={series} type="line" height={350} />
		</div>
	);
};

export default PlanLineChart;
